var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgTesting(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 37.5c-2.5 9.5-12 8-13 0V25m13 12.5v-6.25m0 6.25h3L63 41m-6.5-16H55m1.5 0h3l3.5-3m-6.5 3v6.25M43.5 25h2m-2 0h-3L37 22m8.5 3v-1c0-2.217.83-3.78 2-4.685M45.5 25H55m0 0v-1c0-2.217-.83-3.78-2-4.685m0 0V16m0 3.315a4.494 4.494 0 00-5.5 0m0 0V16m9 15.25H63M43 37.5h-3L36.5 41m7-9.75H37",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 29.5,
    r: 27.5,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.262 52.414l7.356 7.356-14.63 14.631a5.201 5.201 0 11-7.357-7.356l14.631-14.63zM28.262 47.635l3.997 3.998-6.245 6.245-3.997-3.997z",
    stroke: "#504FE9",
    strokeWidth: 2
  })));
}
export default SvgTesting;